import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "locales";
import useViewController from "./viewController";
import "./style.scss";

function PageFooter() {
  const { t } = useTranslation();
  const { isShowFooter } = useViewController();
  if (!isShowFooter) {
    return null;
  }
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__inner">
          <ul className="footer__links">
            <li className="footer__links-item">
              <Link className="footer__link" to="/messages/1">
                {t("Support")}
              </Link>
            </li>
            <li className="footer__links-item">
              <Link className="footer__link" to="/terms">
                {t("Terms of Use")}
              </Link>
            </li>
            <li className="footer__links-item">
              <Link className="footer__link" to="/privacy">
                {t("Privacy Policy")}
              </Link>
            </li>
          </ul>

          {/* "Powered by SMeet" link removed per product decision (2026-05-26).
              Footer keeps only the three legal/support links above. */}
        </div>
      </div>
    </footer>
  );
}

export default PageFooter;
